import { combineReducers } from 'redux'
import loggedIn from './loggedInReducer'



export default combineReducers({
    loggedIn
})
